import { Client } from "../client.model";
import {GenericDgSearchResults} from "./generic.dg-search-results.model";

export class ClientDgSearchResults extends GenericDgSearchResults {
  public results: Client[];

  constructor(total: number, results: Client[], csrfToken: string) {
    super();
    this.total = total;
    this.results = results;
    this.csrfToken = csrfToken;
  }
}

